const REACT_APP_GOOGLE_MAPS_API_KEY = "AIzaSyBBmoRdLVNsEy_0Drke6XOetB-NZPfn91U"
export {
  REACT_APP_GOOGLE_MAPS_API_KEY
};